import { ExportFormHook } from '@app/modules/social-export/hooks/useSocialExportFactory';
import { socialExport } from '@mi-front/api-clients';
import { FacebookPublishForm } from './FacebookPublishForm';
import { FacebookSettingsForm } from './FacebookSettingsForm';

export const useFacebookExport: ExportFormHook<
  socialExport.FacebookPublishDto,
  socialExport.FacebookSettingsDto
> = () => {
  return {
    PublishForm: FacebookPublishForm,
    SettingsForm: FacebookSettingsForm,
  };
};
